// extracted by mini-css-extract-plugin
module.exports = {"root":"tos-module--root--1kbNs"};